import { useEffect } from "react"

import {
    createdBookingLoader,
    createdTimeRequestLoader,
    createdDepositLoader,
} from "modules/BookingCommon/common/queries"
import { Analytics } from "utils/analytics"
import { DefaultSession } from "modules/Booking/AfterPaymentPage/DefaultSession"
import { TimeRequestSession } from "modules/Booking/AfterPaymentPage/TimeRequestSession"
import { DepositSession } from "modules/Booking/AfterPaymentPage/DepositSession"

export function AfterPaymentPage() {
    useEffect(() => {
        Analytics.successful_booking_page_shown()
        Analytics.successful_payment_page_shown()
    }, [])

    return (
        <>
            {!!createdBookingLoader.getHash() && <DefaultSession />}
            {!!createdTimeRequestLoader.getHash() && <TimeRequestSession />}
            {!!createdDepositLoader.getHash() && <DepositSession />}
        </>
    )
}
